import React, { memo } from 'react';
import { View, Switch } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  IconButton,
  IconCopy,
  IconEdit,
  Space,
  IconClose,
  ListItemContainer,
} from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';

export const ListItem = memo(
  ({
    totalHit = -1,
    totalView = -1,
    isVisible,
    children,
    showAvailable = true,
    showCopy = false,
    showEdit = true,
    showDelete = true,
    onEditPressed,
    onCopyPressed,
    onChangeAvailability,
    onDelete,
    dragable = false,
    dragHandle,
    FooterComponent,
    variant,
  }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();
    const hasTotalHit = totalHit !== -1;
    return (
      <ListItemContainer
        {...{ dragable, dragHandle, FooterComponent, variant }}
        StartComponent={
          hasTotalHit && (
            <View>
              <Text style={styles.titleText}>{totalHit}</Text>
              <Text style={styles.subtitleText}>{dictionary.totalHit}</Text>
            </View>
          )
        }
        EndComponent={
          <>
            {showAvailable && (
              <>
                <Switch
                  trackColor={{ true: colors.green1, false: colors.gray22 }}
                  activeThumbColor="white"
                  thumbColor="white"
                  value={isVisible}
                  onValueChange={onChangeAvailability}
                  style={styles.switch}
                />
                <Space size={8} />
              </>
            )}
            {showCopy && (
              <>
                <IconButton
                  style={[
                    styles.actionButton,
                  ]}
                  onPress={onCopyPressed}
                >
                  <IconCopy color={colors.black} />
                </IconButton>
                <Space size={8} />
              </>
            )}
            {showEdit && (
              <>
                <IconButton
                  style={[
                    styles.actionButton,
                  ]}
                  onPress={onEditPressed}
                >
                  <IconEdit color={colors.black}  />
                </IconButton>
                <Space size={8} />
              </>
            )}
            {showDelete && (
              <IconButton
                style={[
                  styles.actionButton,
                ]}
                onPress={onDelete}
              >
                <IconClose color={colors.black}  />
              </IconButton>
            )}
          </>
        }
      >
        {children}
      </ListItemContainer>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  actionButton: {
    width: 25,
    height: 25,
    padding: 6,
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.gray23,
    textAlign: 'left',
  },
  subtitleText: {
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'left',
  },
  switch: {
    width: 43,
    height: 21,
    paddingVertical: 14,
    paddingHorizontal: 0,
    justifyContent: 'center',
  },
}));
